import { generateRandomUUID } from "../utils/uuid";
export class ModalRemoteParty {
    constructor(element, modalUrl) {
        this.element = element;
        this.modalUrl = modalUrl;
    }
    static async Create(modalUrl) {
        const modalId = ModalRemoteParty.getModalFrameId(modalUrl);
        let element = window.top.document.getElementById(modalId);
        if ((element === null || element === void 0 ? void 0 : element.dataset.ready) === 'true') {
            return new ModalRemoteParty(element, modalUrl);
        }
        if (!element) {
            const document = window.top.document;
            element = document.createElement('iframe');
            element.id = modalId;
            element.setAttribute('src', modalUrl);
            element.setAttribute('allowTransparency', 'true');
            element.setAttribute('sandbox', 'allow-same-origin allow-scripts');
            element.dataset.designatedHidden = 'true';
            element.style.display = 'none';
            element.style.position = 'fixed';
            element.style.top = '0';
            element.style.left = '0';
            element.style.backgroundColor = 'transparent';
            element.style.height = '100%';
            element.style.width = '100%';
            element.style.zIndex = '1000000';
            element.style.border = 'none';
            document.body.appendChild(element);
        }
        const constElement = element;
        await new Promise((resolve) => {
            var _a;
            function readyHandler(ev) {
                var _a;
                if (ev.data === 'READY' && ev.origin === modalUrl) {
                    resolve();
                    constElement.dataset.ready = 'true';
                    (_a = window.top) === null || _a === void 0 ? void 0 : _a.removeEventListener('message', readyHandler);
                }
            }
            (_a = window.top) === null || _a === void 0 ? void 0 : _a.addEventListener('message', readyHandler);
        });
        return new ModalRemoteParty(element, modalUrl);
    }
    async doModalSession(cb) {
        let modalWasAlreadyOpen = false;
        const sendRequest = (request) => {
            const channel = new MessageChannel();
            const returnValue = new Promise((resolve, reject) => {
                channel.port2.onmessage = (response) => {
                    const modalResponse = response.data;
                    if ('error' in modalResponse && modalResponse.error === 'ZERO_TRUST_MODAL_ALREADY_OPEN') {
                        modalWasAlreadyOpen = true;
                        reject(modalResponse.error);
                    }
                    else {
                        resolve(modalResponse);
                    }
                };
            });
            this.postMessage(request, channel.port1);
            return returnValue;
        };
        const lockName = `${generateRandomUUID(false)}`;
        const promise = cb(sendRequest);
        this.show();
        await navigator.locks.request(lockName, async () => {
            const topDocument = window.top.document;
            const scriptElement = topDocument.createElement('script');
            this.element.dataset[lockName] = 'lock';
            const modalId = ModalRemoteParty.getModalFrameId(this.modalUrl);
            // Forcefully cleanup ZT modal if modal requesting app goes away without notice (such as when its iframe is deleted from the dom)
            // This works as long as the requester and the top-level is the same origin.
            scriptElement.innerHTML = `{` + /* Start new scope, so pollution is avoided */ `
  let thisScript = document.currentScript;
  navigator.locks.request("${lockName}", () => {
    let element = document.getElementById("${modalId}");
    if (element && element.dataset["${lockName}"]) {
      element.parentNode.removeChild(element);
    }
    (${removeTopDocumentInertness.toString()})();
    thisScript.parentNode.removeChild(thisScript);
  });
}`;
            topDocument.head.appendChild(scriptElement);
            try {
                await promise;
            }
            finally {
                if (!modalWasAlreadyOpen) {
                    this.hide();
                }
                delete this.element.dataset[lockName]; // to signal that we did no go away forcefully
            }
        });
        return promise;
    }
    static getModalFrameId(url) {
        return `zero-trust-party:${url}`;
    }
    postMessage(message, port) {
        var _a;
        (_a = this.element.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(message, this.modalUrl, [port]);
    }
    show() {
        delete this.element.dataset.designatedHidden;
        this.element.style.display = 'block';
        this.element.style.pointerEvents = 'auto';
        this.makeTopDocumentInert();
        this.element.focus();
    }
    hide() {
        this.element.style.pointerEvents = 'none';
        this.element.dataset.designatedHidden = 'true';
        setTimeout(() => {
            if (this.element.dataset.designatedHidden === 'true') { // so that it only gets hidden if someone did not call show() since this hide() was called (such as other instances of this lib/class)
                this.element.style.display = 'none';
                removeTopDocumentInertness();
            }
        }, 500);
    }
    makeTopDocumentInert() {
        var _a;
        // This serves as a focus trap
        (_a = window.top) === null || _a === void 0 ? void 0 : _a.document.body.childNodes.forEach(child => {
            if (child.getAttribute) {
                const element = child;
                if (!element.getAttribute('inert') && element !== this.element) {
                    element.setAttribute('inert', 'ztModal');
                }
            }
        });
    }
}
function removeTopDocumentInertness() {
    var _a;
    (_a = window.top) === null || _a === void 0 ? void 0 : _a.document.body.childNodes.forEach(child => {
        if (child.getAttribute) {
            const element = child;
            if (element.getAttribute('inert') === 'ztModal') {
                element.removeAttribute('inert');
            }
        }
    });
}
